import { render, staticRenderFns } from "./Travel-for-work.vue?vue&type=template&id=0b81dfa5"
import script from "./Travel-for-work.vue?vue&type=script&lang=js"
export * from "./Travel-for-work.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports